import { PromoCampaign } from "./types"

export const promoCampaign: PromoCampaign = {
  content: {
    codemetrics: {
      logo: "Codemetrics",
      title: "Score code, devs, and debt fast.",
      link: "https://codemetrics.ai/?utm_source=hellobar&utm_medium=banner&utm_campaign=cm_hello_bar",
      CTAText: "Start free trial",
      variant: "accent",
    },
    mongoDB: {
      logo: "MongoDB",
      title: "MongoDB Atlas is built for every app.",
      link: "https://www.mongodb.com/lp/cloud/atlas/try3",
      CTAText: "Start Building",
      variant: "teal",
    },
  },
  image: {
    "mongoDB-2": {
      images: {
        title: "MongoDB",
        desktop: "mongo-desktop.png",
        desktopLink:
          "https://srv.buysellads.com/ads/long/x/TH2C5ZSVTTTTTT6BV6INETTTTTTPLYJH2TTTTTTT54N4OBTTTTTTTYZJCHWMPML2VQAF45ZI23DW5JLYFTBWN2BB5QST",
        mobile: "mongo-mobile.png",
        mobileLink:
          "https://srv.buysellads.com/ads/long/x/TCRC6KDVTTTTTTDBVEACETTTTTT6L77B2TTTTTTTL4WITBTTTTTTTYZJCHWMPML2VQAF45ZI23DW5JLYFTBWN2BB5QST",
      },
    },
    metronome: {
      images: {
        title: "Metronome",
        desktop: "metronome-desktop.png",
        desktopLink:
          "https://srv.buysellads.com/ads/long/x/TF2KKGSVTTTTTTD7TESCETTTTTTVUWQM2TTTTTTTOTCIOBTTTTTTTJ4P27JCCYSMFT7H5JB6ZQNUV7QL57AHVOD3QQ3E",
        mobile: "metronome-mobile.png",
        mobileLink:
          "https://srv.buysellads.com/ads/long/x/TF2KKGSVTTTTTTD7TESCETTTTTTV7WQM2TTTTTTTOTCIOBTTTTTTTJ4P27JCCYSMFT7H5JB6ZQNUV7QL57AHVOD3QQ3E",
      },
    },
    "metronome-2": {
      images: {
        title: "Metronome",
        desktop: "metronome-2-desktop.png",
        desktopLink:
          "https://srv.buysellads.com/ads/long/x/TFH36MZVTTTTTTDPB35CETTTTTTKO3BX2TTTTTTTADKMPBTTTTTTTAPKPHPMKWDM5JWMLKP6222D62B52QTUPJZG2HIT",
        mobile: "metronome-2-mobile.png",
        mobileLink:
          "https://srv.buysellads.com/ads/long/x/TF24YMZVTTTTTTDBR75CETTTTTTKT5PX2TTTTTTTODIMPBTTTTTTTAPKPHPMKWDM5JWMLKP6222D62B52QTUPJZG2HIT",
      },
    },
    smythOS: {
      images: {
        title: "SmythOS",
        desktop: "smythos-desktop.png",
        desktopLink: "https://github.com/SmythOS/sre",
        mobile: "smythos-mobile.png",
        mobileLink: "https://github.com/SmythOS/sre",
      },
    },
  },
}
